import Favorite from 'components/Icons/components/FavoriteHeart'
import styled from 'styled-components'
import { mainHeaderColor } from 'utils/style-utils'

interface Props {
  active?: boolean
}

export const FavoriteIcon = styled(Favorite).withConfig({
  shouldForwardProp: (prop: any) => prop !== 'active',
})<Props>`
  fill: ${mainHeaderColor};
  width: 1.125rem;
  height: 1.125rem;
  cursor: pointer;

  path {
    fill-rule: ${({ active }) => (active ? 'nonzero' : 'evenodd')};
  }

  &:hover {
    path {
      fill-rule: ${({ active }) => (!active ? 'nonzero' : 'evenodd')};
    }
  }
`
